
import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const faqs = [
  {
    question: '¿Qué riesgos tiene usar software pirata en mi empresa?',
    answer: 'El uso de software pirata expone a tu empresa a sanciones legales con multas significativas, vulnerabilidades de seguridad (malware, ransomware), pérdida de datos, inestabilidad del sistema y daño reputacional. En Argentina, la Ley 11.723 protege los derechos de autor del software.',
  },
  {
    question: '¿Qué tipos de licencias de software existen?',
    answer: 'Existen licencias perpetuas (pago único, uso indefinido), por suscripción (pago mensual/anual con actualizaciones incluidas), por volumen (descuentos para múltiples equipos), OEM (vinculadas al hardware) y licencias académicas o sin fines de lucro con precios especiales.',
  },
  {
    question: '¿Cómo sé si mi empresa necesita regularizar sus licencias?',
    answer: 'Realizamos una auditoría gratuita de software donde relevamos todos los programas instalados en tus equipos y verificamos el estado de cada licencia. Te entregamos un informe detallado con las irregularidades encontradas y las opciones para regularizar.',
  },
  {
    question: '¿Ofrecen planes de pago para la compra de licencias?',
    answer: 'Sí, trabajamos con planes de pago flexibles y financiación para que puedas regularizar el software de tu empresa sin afectar tu flujo de caja. Consultanos por las opciones disponibles según el volumen de licencias que necesites.',
  },
  {
    question: '¿Las licencias incluyen soporte técnico?',
    answer: 'Todas las licencias que comercializamos incluyen nuestro soporte técnico para instalación, activación y configuración. Además, tenés acceso al soporte oficial del fabricante durante la vigencia de la licencia.',
  },
  {
    question: '¿Pueden migrar mi empresa a Microsoft 365 o Google Workspace?',
    answer: 'Sí, realizamos migraciones completas a plataformas cloud como Microsoft 365 y Google Workspace. Incluimos la configuración de cuentas, migración de correos, archivos y capacitación para tu equipo de trabajo.',
  },
];

export function SoftwareFAQ() {
  const { ref, isVisible } = useScrollAnimation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(255,45,155,0.03),transparent_60%)]"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`text-center mb-14 anim-fade-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Preguntas <strong className="text-neon-400 text-neon-glow-sm">Frecuentes</strong>
          </h2>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">
            Resolvemos tus dudas sobre licencias de software y regularización
          </p>
          <div className="neon-line max-w-xs mx-auto mt-6 opacity-40"></div>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-950/80 rounded-xl border border-gray-800 overflow-hidden transition-all duration-300 hover:border-gray-700"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer group"
              >
                <span className="text-sm font-semibold text-white group-hover:text-neon-400 transition-colors pr-4">
                  {faq.question}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-lg border transition-all duration-300 flex-shrink-0 ${openIndex === index ? 'bg-neon-400/20 border-neon-400/40 rotate-180' : 'bg-gray-800 border-gray-700'}`}>
                  <i className={`ri-arrow-down-s-line text-base ${openIndex === index ? 'text-neon-400' : 'text-gray-500'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-400 ${openIndex === index ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="px-6 pb-5 text-sm text-gray-400 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
